import FlexViewTwo from "../components/FlexView/FlexViewTwo/FlexViewTwo"
import LinksCard from "../components/cards/LinksCard"
import PrimaryCard from "../components/cards/PrimaryCard"
import pagesNames from "../constants/pages-names"
import Footer from "../layouts/Footer"
import MainHeader from "../layouts/MainHeader"

const ResourcesPage = () => {
  return (
    <main id="main" className="page">
      <div className="sticky-view">
        <div className="sticky-container">
          <MainHeader 
            title="ESG Resource hub"
            image={{
              src : require('../assets/images/wallpaper/resource.jpg'),
              alt : "ESG Resource hub background"
            }}
          />
        </div>
        <div className="sticky-container-two">
          <div className="wrapper-small">
            <div className="space-50"></div>
            <div className="space-50"></div>
            <p className="text-paragraph">As reporting standards evolve and are implemented globally, we remain dedicated to adapting our approach to ESG disclosures in accordance with regulatory guidelines and industry norms.</p>
            <FlexViewTwo>
              <PrimaryCard
                title="Reports"
                image={{
                  src : require(`../assets/images/cards/resource-2.jpg`),
                  alt : "Resource card one"
                }}
                button={{
                  text : "Read More",
                  path : pagesNames.reports,
                }}
              /> 
              <PrimaryCard
                title="ESG Profile"
                image={{
                  src : require(`../assets/images/cards/resource-1.jpg`),
                  alt : "Resource card one"
                }}
                button={{
                  text : "Read More",
                  path : pagesNames.esgProfile,
                }}
              /> 
            </FlexViewTwo>

            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
          </div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  )
}

export default ResourcesPage